

import React from "react";
import PropTypes from "prop-types";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { styled } from "@mui/material/styles";

// Custom Styled Tooltip with Left Alignment
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 400, // Set a reasonable width
    textAlign: "left", // Ensure left alignment
  },
});

function ChartHeader({
  title,
  description = "",
  profilePictures = [],
  is_derived = false,
  children = null
}) {
  return (
    title && (
      <MDBox
        mx={2}
        mt={-3}
        py={1}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
        display="flex"
        alignItems="center"
        gap={2} // Space between Title+Icon and Profile Pictures
        flexWrap="wrap"
      >
        {/* 🟦 Title and Info Icon */}
        <MDBox display="flex" alignItems="center">
          {/* <MDTypography
            id="chart-title"
            variant="h6"
            color="white"
            sx={{ // Use sx prop for inline styles
              fontSize: "1rem",
              lineHeight: "1.5",
              fontWeight: "600",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </MDTypography> */}
          <MDBox sx={{ width: "100%", minWidth: "100px", margin: "0 auto" }}>
            <MDTypography
              id="chart-title"
              variant="h6"
              color="white"
              sx={{
                fontSize: "1rem",
                lineHeight: "1.5",
                fontWeight: "600",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "left", // Optional: Center-align the text
              }}
            >
              {title}
            </MDTypography>
          </MDBox>

          {/* ℹ️ Info Icon with Tooltip */}
          {description && (
            <CustomTooltip
              title={description}
              placement="bottom"
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, 10],
                    },
                  },
                ],
              }}
            >
              <IconButton sx={{ color: "white", p: 0, ml: 0.5 }}>
                <InfoOutlinedIcon fontSize="small" />
              </IconButton>
            </CustomTooltip>
          )}
        </MDBox>

        {/* 🟦 Profile Pictures */}
        {profilePictures.length > 0 && (
          <MDBox display="flex" alignItems="center" ml={2}>
            <AvatarGroup max={4} sx={{ "& .MuiAvatar-root": { width: 32, height: 32 } }}>
              {profilePictures.map((pic, index) => (
                <Avatar
                  key={index}
                  src={pic}
                  alt={`Profile ${index + 1}`}
                  sx={{ width: 32, height: 32 }}
                />
              ))}
            </AvatarGroup>
          </MDBox>
        )}

        {/* Render Children (Action Buttons like Ask AI) */}
        {children && (
          <MDBox ml="auto" display="flex" alignItems="center">
            {children}
          </MDBox>
        )}
      </MDBox>

    )
  );
}

ChartHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  profilePictures: PropTypes.arrayOf(PropTypes.string),
  is_derived: PropTypes.bool,
  children: PropTypes.node, // ✅ Add children prop type
};

export default ChartHeader;
